import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'
import { wrapViewTransition } from '../helpers/view_transitions'

export default class extends Controller {
  static targets = ['dialog']
  static values = {
    redirectToOnClose: { type: String, default: null },
    refreshOnClose: { type: Boolean, default: false },
    modal: { type: Boolean, default: true },
    dismissible: { type: Boolean, default: true }
  }

  connect () {
    this.element.dispatchEvent(new CustomEvent('connect'))
    useIntersection(this)

    this.boundCloseAllDialogs = this.closeAllDialogs.bind(this)
    document.addEventListener('turbo:before-cache', this.boundCloseAllDialogs)

    if (this.hasDialogTarget && !this.dismissibleValue) {
      this.boundPreventDismiss = this.preventDismiss.bind(this)
      this.dialogTarget.addEventListener('cancel', this.boundPreventDismiss)
    }
  }

  disconnect () {
    document.removeEventListener('turbo:before-cache', this.boundCloseAllDialogs)

    if (this.boundPreventDismiss && this.hasDialogTarget) {
      this.dialogTarget.removeEventListener('cancel', this.boundPreventDismiss)
    }
  }

  preventDismiss (event) {
    event.preventDefault()
  }

  open () {
    this.closeAllDialogs()
    if (this.modalValue) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.show()
    }
  }

  close () {
    wrapViewTransition(() => {
      this.dialogTarget.close()
      if (this.redirectToOnCloseValue) {
        window.Turbo.visit(this.redirectToOnCloseValue, { action: 'replace' })
      } else if (this.refreshOnCloseValue) {
        window.Turbo.visit(window.location.href, { action: 'replace' })
      }
    })
  }

  closeAllDialogs () {
    document.querySelectorAll('dialog[open]').forEach(dialog => {
      if (this.hasDialogTarget && dialog.contains(this.dialogTarget)) return
      dialog.close()
    })
  }
}
